import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { Toaster } from "sonner";
import { authConfig } from "./lib/auth";
import { queryClient } from "./lib/query-client";
import { captureError, initSentry } from "./lib/sentry";
import { routeTree } from "./routeTree.gen";
import "./styles.css";

initSentry();

const router = createRouter({
  routeTree,
  defaultErrorComponent: ({ error }) => {
    captureError(error);
    // Re-throw so TanStack Router still renders its own error UI.
    throw error;
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById("root");
if (!root) throw new Error("#root element not found");

createRoot(root).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<span />} onError={captureError}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider {...authConfig}>
          <RouterProvider router={router} />
          <Toaster richColors closeButton position="bottom-right" />
        </AuthProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
